import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { download } from "../lib/helpers";
import { colors } from "../lib/constants";

interface Props {
  open: boolean;
  title: React.ReactNode;
  content: string;
  // name of the file when downloaded from the modal
  filename: string;
  // shown instead of the content when there is nothing to show
  emptyMessage?: React.ReactNode;
  onClose: () => void;
}

// Shows the transcription or the chat messages of a meeting, with the file to
// download if wanted.
export const TextModal: React.FC<Props> = ({
  open,
  title,
  content,
  filename,
  emptyMessage,
  onClose,
}) => (
  <Modal open={open} onClose={onClose}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "min(800px, 90vw)",
        maxHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        bgcolor: "background.paper",
        borderRadius: "12px",
        boxShadow: 24,
        p: 3,
      }}
    >
      <Typography
        sx={{ fontSize: "18px", fontWeight: 600, color: colors.purple }}
      >
        {title}
      </Typography>
      <Box
        component="pre"
        sx={{
          flex: 1,
          overflow: "auto",
          m: 0,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontFamily: "inherit",
          fontSize: "14px",
          color: colors.greyBlue,
        }}
      >
        {content || emptyMessage}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          <FormattedMessage id="actions.close" defaultMessage="Close" />
        </Button>
        <Button
          variant="contained"
          disabled={!content}
          startIcon={<FontAwesomeIcon icon={faDownload} />}
          onClick={() => download(filename, content)}
        >
          <FormattedMessage id="actions.download" defaultMessage="Download" />
        </Button>
      </Box>
    </Box>
  </Modal>
);
